import { LoginResponse, TicketControl } from '@/models/catracasZerofilaModel';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	clientCatraca: {} as LoginResponse,
	catracaData: {} as TicketControl,
	pageCatraca: 0,
};

const controleCatracasSlice = createSlice({
	name: 'controleCatracas',
	initialState,
	reducers: {
		reset: () => initialState,
		changeControleCatracasLoginData: (state, action) => {
			state.clientCatraca = action.payload;
		},
		changeCatracaData: (state, action) => {
			state.catracaData = action.payload;
		},
		changePageCatraca: (state, action) => {
			state.pageCatraca = action.payload;
		},
	},
});

export const { reset, changeControleCatracasLoginData, changePageCatraca, changeCatracaData } = controleCatracasSlice.actions;
export default controleCatracasSlice.reducer;
